module.exports = __webpack_public_path__ + "static/img/lp5_en.26abc70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp5_en.png
// module id = x4TW
// module chunks = 0